import { calcSumAlienSelectedElements } from '@entities/order-item'
import { IOrderElement, ICheckChangeOrderPayload } from './../model/types'

const checkChangeOrder = (payload: ICheckChangeOrderPayload) => {
  const {
    newOrderData,
    guestId,
    oldArrayElements,
    oldDiscount,
    waiter,
    payedStatus,
    prepayment
  } = payload

  // Другой пользователь отметил позиции во время оплаты
  const oldSummAlienOrder: number = calcSumAlienSelectedElements(
    oldArrayElements,
    guestId
  )
  const newSummAlienOrder: number = calcSumAlienSelectedElements(
    newOrderData.ordersElementAll,
    guestId
  )

  const message: string[] = []

  if (newOrderData.waiter && waiter && waiter.id !== newOrderData.waiter.id) {
    message.push('Сменился официант')
  }

  if (oldSummAlienOrder !== newSummAlienOrder && payedStatus) {
    message.push('Сумма оплаты изменилась, так как другой гость выбрал позицию, которую вы хотели оплатить.')
  }

  const ResPrepayment = newOrderData.prepayment !== null ? newOrderData.prepayment / 100 : null

  const newSummOrder = newOrderData.ordersElementAll.reduce((acc: number, element: IOrderElement) => {
    acc = acc + element.price
    return acc
  }, 0)

  const oldSummOrder = oldArrayElements.reduce((acc: number, element: IOrderElement) => {
    acc = acc + element.price
    return acc
  }, 0)

  if (newSummOrder !== oldSummOrder) {
    message.push('Сумма оплаты изменилась')
  }

  if (oldDiscount !== newOrderData.discount / 100 || prepayment !== ResPrepayment) {
    message.push('Сумма оплаты изменилась')
  }

  // Состав заказа изменился
  const oldArrayID: number[] = oldArrayElements.map((i: IOrderElement) => i.id)
  const newArrayID: number[] = newOrderData.ordersElementAll.map((i: IOrderElement) => i.id)
  const compareArrays: boolean =
    oldArrayID.length === newArrayID.length &&
    oldArrayID.every((v: number, i: number): boolean => v === newArrayID[i])
  if (!compareArrays) {
    message.push('Состав заказа изменился')
  }

  if (message.length) {
    return message.join(', ')
  }

  return false
}

export default checkChangeOrder
